import { calculateMaxScore, calculateScore } from 'bundles/author-assignment-grading/utils/SubmissionGradeUtils';
import { getPercentGradeFromDecimal } from 'bundles/author-common/utils/GradeUtils';
import type { CourseGrade, ItemGrade } from 'bundles/authoring/common/types/gradebookV2';
import type OnDemandStaffGradedAssignmentsV4 from 'bundles/naptimejs/resources/OnDemandStaffGradedAssignments.v4';
import type OnDemandStaffGradedEvaluationsV2 from 'bundles/naptimejs/resources/onDemandStaffGradedEvaluations.v2';
import type OnDemandStaffGradedSubmissionsV3 from 'bundles/naptimejs/resources/onDemandStaffGradedSubmissions.v3';
import type StaffGradedAutoGradedQuizSubmissionsV1 from 'bundles/naptimejs/resources/staffGradedAutoGradedQuizSubmissions.v1';

import _t from 'i18n!nls/author-assignment-grading';

export default (
  assignment: OnDemandStaffGradedAssignmentsV4,
  evaluation: OnDemandStaffGradedEvaluationsV2,
  submission: OnDemandStaffGradedSubmissionsV3,
  quizSubmission?: StaffGradedAutoGradedQuizSubmissionsV1,
  gradebookGrade: ItemGrade | {} = {}
) => {
  const scoreOverride = evaluation && evaluation.scoreOverride && evaluation.scoreOverride.score;
  const evaluationScore =
    scoreOverride ||
    calculateScore(evaluation && evaluation.parts, assignment.evaluationSchema.parts) +
      (quizSubmission && quizSubmission.evaluation ? quizSubmission.evaluation.score : 0);
  const maxScore =
    calculateMaxScore(assignment.evaluationSchema.parts) +
    (quizSubmission && quizSubmission.evaluation ? quizSubmission.evaluation.maxScore : 0);

  const originalOutcome = { grade: getPercentGradeFromDecimal(evaluationScore / maxScore) };

  // @ts-expect-error TSMIGRATION
  const liveOutcome = gradebookGrade.liveOutcome || originalOutcome;
  return { grade: { ...gradebookGrade, liveOutcome, originalOutcome } };
};

export const getCurrentGrade = (grade?: ItemGrade): number | undefined => {
  return ((grade || {}).liveOutcome || {}).grade || ((grade || {}).originalOutcome || {}).grade;
};

export const getCurrentCourseGrade = (grade?: CourseGrade): number | undefined => {
  return ((grade || {}).liveCourseOutcome || {}).courseGrade || ((grade || {}).originalCourseOutcome || {}).courseGrade;
};

export const getOriginalCourseGrade = (grade?: CourseGrade): number | undefined => {
  return ((grade || {}).originalCourseOutcome || {}).courseGrade;
};

export const getOverrideCourseGrade = (grade?: CourseGrade): number | undefined => {
  return ((grade || {}).overrideCourseOutcome || {}).courseGrade;
};

export const getGradeVisibility = (grade?: ItemGrade): string => {
  if (!grade) {
    return '--';
  }
  return grade.isHidden ? _t('Hidden') : _t('Visible');
};
